import { defineMessages } from '../define';

export default defineMessages({
  'profile.title': { ru: 'Профиль', en: 'Profile' },
  'profile.rendered': { ru: 'Смонтировано роликов', en: 'Reels edited' },
  'profile.available': { ru: 'Доступно монтажей', en: 'Edits available' },
  'profile.analytics': { ru: 'Аналитика', en: 'Analytics' },
  'profile.analytics.hint': { ru: 'Пользователи, подписки и видео', en: 'Users, subscriptions and videos' },
  'profile.support': { ru: 'Поддержка', en: 'Support' },
  'profile.support.hint': { ru: 'Ответы на вопросы и связь с нами', en: 'Answers to common questions and how to reach us' },
  'profile.renewalOff': { ru: 'Автопродление отключено. Доступ до ', en: 'Auto-renewal is off. Access until ' },
  'profile.renewalNext': { ru: 'Следующее продление: ', en: 'Next renewal: ' },
  'profile.manageTribute': { ru: 'Управлять подпиской в Tribute', en: 'Manage subscription in Tribute' },
  'profile.cancelling': { ru: 'Отключаем…', en: 'Turning off…' },
  'profile.cancel': { ru: 'Отключить автопродление', en: 'Turn off auto-renewal' },
  'profile.docs': { ru: 'Документы', en: 'Documents' },
  'profile.terms': { ru: 'Публичная оферта', en: 'Terms of service' },
  'profile.privacy': { ru: 'Политика конфиденциальности', en: 'Privacy policy' },
  'profile.telegramUser': { ru: 'Пользователь Telegram', en: 'Telegram user' },
  'app.booting': { ru: 'Готовим редактор', en: 'Getting the editor ready' },
  'profile.language': { ru: 'Язык', en: 'Language' },
  'profile.language.system': { ru: 'Как в системе', en: 'System' },
});
